import { Component, Input } from '@angular/core';
import { AbstractDialogComponent } from '../../../../Core/Dialogs/components/AbstractDialog/abstract-dialog.component';
import { CoreDialogService } from '../../../../Core/Dialogs/services/dialog.service';

@Component({
    selector: 'agpr-image-light-box',
    templateUrl: './image-light-box.component.html',
    styleUrls: ['./image-light-box.component.scss'],
    standalone: false
})
export class ImageLightBoxComponent extends AbstractDialogComponent {
    @Input() public id: string;

    @Input() src: string;
    @Input() alt: string = 'Briefing.preview';
    @Input() modal: boolean = true;
    @Input() width: number;
    @Input() height: number;

    constructor(coreDialogService: CoreDialogService) {
        super(coreDialogService, 'ImageLightBox');
    }
}
